import type { ToastErrorPayload } from '@/lib/format-api-error'
import { ApiError } from '@/lib/api'
import { formatApiError } from '@/lib/format-api-error'
import { m } from '@/lib/paraglide/messages'

// Builds a sonner toast payload for warehouse-position mutations.
//
// Title: never the raw English server string — the UI is single-locale. The
// server's `mapPositionErr` only returns CONFLICT for ErrDuplicateCode, so that
// code always means "mã vị trí đã có người dùng"; everything else keeps the
// caller's Vietnamese label. Description: stable error code + request ID (via
// formatApiError) so the code stays quotable for support.
export function warehousePositionErrorToast(
    err: unknown,
    fallback: string,
): ToastErrorPayload {
    const { description } = formatApiError(err, fallback)
    const title =
        err instanceof ApiError && err.code === 'CONFLICT'
            ? m.warehouse_position_toast_duplicate_code()
            : fallback
    return { title, description }
}
